import { render, staticRenderFns } from "./CookHomeView.vue?vue&type=template&id=25406e84&"
import script from "./CookHomeView.vue?vue&type=script&lang=ts&"
export * from "./CookHomeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports